// ==================================================================================================
//
// Close flash message
//
// ==================================================================================================
const closeFlashMessage = () => {
  let props = {};
  let els = {};

  // Cache dom element selectors
  // ------------------------------------------------
  const createChildren = () => {
    els.$flashMessage = $('.js-flash-group')
    els.$closeButton = $('.js-close-flash-message')
    return;
  }

  // Close flash message
  // ------------------------------------------------
  const closeFlashMessage = () => {
    els.$flashMessage.slideUp(300, () => els.$flashMessage.remove())
  }

  // Enable
  // ------------------------------------------------
  const enable = () => {
    if (props.isEnabled) return;

    // Add your event handlers here
    if (els.$flashMessage) els.$closeButton.on('click', closeFlashMessage)

    props.isEnabled = true;

    return;
  }

  // Disable
  // ------------------------------------------------
  const disable = () => {
    if (!props.isEnabled) return;

    // Remove your event handlers here
    if (els.$flashMessage) els.$closeButton.off('click', closeFlashMessage)

    props.isEnabled = false;

    return;
  }

  // Init
  // ------------------------------------------------
  const init = () => {
    createChildren();
    enable();
    return;
  }

  return {
    init,
    enable,
    disable
  };
}

export default closeFlashMessage;
